var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListTracksPage',{attrs:{"datatable-config":this.datatableConfig,"get-tracks-function":_vm.getTracksFunction,"export-route-name":"export-resort-tracks"}})}
var staticRenderFns = []

export { render, staticRenderFns }